import { useMutation } from '@tanstack/react-query';

import { cancelMarketplaceOrder } from '../data-access/api';

/**
 * @returns cancelOrder mutation object
 */
export const useCancelOrderMutation = () =>
	useMutation({ mutationFn: (payload: string) => cancelMarketplaceOrder(payload) });
